import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import LogoMark from "@/components/LogoMark";
import { SERVICES, PHONE_DISPLAY, PHONE_LINK, EMAIL, ZONE } from "@/data/content";

const NAV = [
  { to: "/", label: "Accueil", id: "accueil" },
  { to: "/services", label: "Nos services", id: "services" },
  { to: "/a-propos", label: "À propos", id: "about" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-gold/20 bg-noir">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 pb-14 pt-16 sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1.3fr] lg:px-10">
        <div>
          <Link to="/" data-testid="footer-brand-logo" className="flex items-center gap-2.5">
            <LogoMark className="h-12 w-12 shrink-0" />
            <span className="flex flex-col leading-none">
              <span className="block font-serif text-[26px] tracking-[0.16em] text-gold">
                PUREVA
              </span>
              <span className="mt-0.5 block text-[9.5px] font-medium uppercase tracking-[0.04em] text-ivory/85">
                Nettoyage haut de gamme
              </span>
            </span>
          </Link>
          <p className="mt-6 max-w-xs text-[15px] leading-relaxed text-mist">
            PUREVA offre des services de nettoyage professionnel haut de gamme
            pour les immeubles, les bureaux et les espaces commerciaux.
          </p>
          <div className="mt-8 flex h-14 w-14 items-center justify-center rounded-full border border-gold/50">
            <span className="font-serif text-2xl text-gold">P</span>
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">
            Navigation
          </p>
          <ul className="mt-6 space-y-3.5">
            {NAV.map((l) => (
              <li key={l.id}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.id}`}
                  className="text-[15px] text-ivory/80 transition-colors hover:text-gold"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">
            Nos services
          </p>
          <ul className="mt-6 space-y-3.5">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`footer-service-${s.slug}`}
                  className="text-[15px] text-ivory/80 transition-colors hover:text-gold"
                >
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">
            Contact
          </p>
          <ul className="mt-6 space-y-4">
            <li>
              <a
                href={PHONE_LINK}
                data-testid="footer-phone-link"
                className="inline-flex items-center gap-3 text-[15px] text-ivory/80 transition-colors hover:text-gold"
              >
                <Phone className="h-4 w-4 text-gold" />
                {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${EMAIL}`}
                data-testid="footer-email-link"
                className="inline-flex items-center gap-3 text-[15px] text-ivory/80 transition-colors hover:text-gold"
              >
                <Mail className="h-4 w-4 text-gold" />
                {EMAIL}
              </a>
            </li>
            <li>
              <p
                data-testid="footer-zone-text"
                className="inline-flex items-center gap-3 text-[15px] text-ivory/80"
              >
                <MapPin className="h-4 w-4 text-gold" />
                {ZONE}
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gold/10">
        <p className="mx-auto max-w-7xl px-6 py-6 text-center text-xs tracking-[0.12em] text-mist lg:px-10">
          © {year} PUREVA. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}
